import React from 'react';
import {
    Button,
    Collapse,
    CollapseProps,
    Flex,
    Space,
    Typography,
    QRCode,
} from 'antd';
import { Link } from 'react-router-dom';

import { useTheme } from '../../../../../hooks/useTheme';

type Props = {
    readonly loading: boolean;
    readonly updateFn: () => void;
};

const { Text } = Typography;

export const AddCommunity = ({ updateFn, loading }: Props) => {
    const token = useTheme();

    const botName = window.ENV.TELEGRAM_BOT;
    const botInviteLink = `tg://resolve?domain=${botName}`;

    const items: CollapseProps['items'] = [
        {
            key: '1',
            label: 'Как добавлять сообщества',
            children: (
                <Flex vertical gap={24}>
                    <Space direction='vertical' style={{ width: '100%' }}>
                        <Text>
                            Для добавления сообщества (группы или канала)
                            Telegram в личный кабинет Spodial перейдите{' '}
                            <Link
                                style={{ color: token.colorPrimary }}
                                target='_blank'
                                to={botInviteLink}
                            >
                                по ссылке
                            </Link>
                        </Text>
                        <Text>или отсканируйте QR-code</Text>
                    </Space>

                    <QRCode
                        style={{
                            padding: 0,
                        }}
                        size={200}
                        value={botInviteLink}
                    />

                    <Space>
                        <Button disabled={loading} onClick={() => updateFn()}>
                            Обновить список сообществ
                        </Button>
                    </Space>
                </Flex>
            ),
        },
    ];

    return <Collapse defaultActiveKey={['1']} items={items} />;
};
